/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientPersonalInformation
 */
export interface ClientPersonalInformation {
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    readonly user?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    readonly url?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    cityOfBirth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    countryOfBirth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    readonly fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    department?: ClientPersonalInformationDepartmentEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientPersonalInformation
     */
    readonly departmentChoices?: Array<string>;
    /**
     * 
     * @type {Blob}
     * @memberof ClientPersonalInformation
     */
    userPhoto?: Blob;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    readonly userPhotoUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientPersonalInformation
     */
    dateOfBirth?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientPersonalInformation
     */
    aliases?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    nationality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    taxationCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    vatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    taxIdType?: ClientPersonalInformationTaxIdTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    taxIdNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    streetAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    county?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    postcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalInformation
     */
    readonly westburyId?: string;
}


/**
 * @export
 */
export const ClientPersonalInformationDepartmentEnum = {
    Membership: 'Membership',
    Discography: 'Discography',
    Distribution: 'Distribution'
} as const;
export type ClientPersonalInformationDepartmentEnum = typeof ClientPersonalInformationDepartmentEnum[keyof typeof ClientPersonalInformationDepartmentEnum];

/**
 * @export
 */
export const ClientPersonalInformationTaxIdTypeEnum = {
    TinTaxpayerIdentificationNumber: 'TIN - Taxpayer Identification Number',
    ItinIndividualTaxpayerIdentificationNumber: 'ITIN - Individual Taxpayer Identification Number',
    FtinForeignTaxpayerIdentificationNumber: 'FTIN - Foreign Taxpayer Identification Number',
    PibPoreskiIdentifikacioniBroj: 'PIB - Poreski Identifikacioni Broj',
    PpsPersonalPublicService: 'PPS - Personal Public Service',
    NipNumerIdentyfikacjiPodatkowej: 'NIP - Numer Identyfikacji Podatkowej',
    FederalTaxId: 'Federal Tax ID',
    DepartmentOfStateId: 'Department of State ID',
    NationalInsuranceNumber: 'National Insurance Number',
    SocialSecurityNumber: 'Social Security Number'
} as const;
export type ClientPersonalInformationTaxIdTypeEnum = typeof ClientPersonalInformationTaxIdTypeEnum[keyof typeof ClientPersonalInformationTaxIdTypeEnum];


/**
 * Check if a given object implements the ClientPersonalInformation interface.
 */
export function instanceOfClientPersonalInformation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClientPersonalInformationFromJSON(json: any): ClientPersonalInformation {
    return ClientPersonalInformationFromJSONTyped(json, false);
}

export function ClientPersonalInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientPersonalInformation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : json['user'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'oldPassword': !exists(json, 'old_password') ? undefined : json['old_password'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'cityOfBirth': !exists(json, 'city_of_birth') ? undefined : json['city_of_birth'],
        'countryOfBirth': !exists(json, 'country_of_birth') ? undefined : json['country_of_birth'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'firstName': !exists(json, 'first_name') ? undefined : json['first_name'],
        'middleName': !exists(json, 'middle_name') ? undefined : json['middle_name'],
        'lastName': !exists(json, 'last_name') ? undefined : json['last_name'],
        'department': !exists(json, 'department') ? undefined : json['department'],
        'departmentChoices': !exists(json, 'department_choices') ? undefined : json['department_choices'],
        'userPhoto': !exists(json, 'user_photo') ? undefined : json['user_photo'],
        'userPhotoUrl': !exists(json, 'user_photo_url') ? undefined : json['user_photo_url'],
        'dateOfBirth': !exists(json, 'date_of_birth') ? undefined : (json['date_of_birth'] === null ? null : new Date(json['date_of_birth'])),
        'aliases': !exists(json, 'aliases') ? undefined : json['aliases'],
        'nationality': !exists(json, 'nationality') ? undefined : json['nationality'],
        'taxationCountry': !exists(json, 'taxation_country') ? undefined : json['taxation_country'],
        'vatNumber': !exists(json, 'vat_number') ? undefined : json['vat_number'],
        'taxIdType': !exists(json, 'tax_id_type') ? undefined : json['tax_id_type'],
        'taxIdNumber': !exists(json, 'tax_id_number') ? undefined : json['tax_id_number'],
        'emailAddress': !exists(json, 'email_address') ? undefined : json['email_address'],
        'streetAddress': !exists(json, 'street_address') ? undefined : json['street_address'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'phoneNumber': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'county': !exists(json, 'county') ? undefined : json['county'],
        'postcode': !exists(json, 'postcode') ? undefined : json['postcode'],
        'westburyId': !exists(json, 'westbury_id') ? undefined : json['westbury_id'],
    };
}

export function ClientPersonalInformationToJSON(value?: ClientPersonalInformation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'old_password': value.oldPassword,
        'password': value.password,
        'title': value.title,
        'gender': value.gender,
        'city_of_birth': value.cityOfBirth,
        'country_of_birth': value.countryOfBirth,
        'first_name': value.firstName,
        'middle_name': value.middleName,
        'last_name': value.lastName,
        'department': value.department,
        'user_photo': value.userPhoto,
        'date_of_birth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0,10)),
        'aliases': value.aliases,
        'nationality': value.nationality,
        'taxation_country': value.taxationCountry,
        'vat_number': value.vatNumber,
        'tax_id_type': value.taxIdType,
        'tax_id_number': value.taxIdNumber,
        'email_address': value.emailAddress,
        'street_address': value.streetAddress,
        'country': value.country,
        'phone_number': value.phoneNumber,
        'county': value.county,
        'postcode': value.postcode,
    };
}

